import React from 'react';
import {
  InnerCircle,
  LabelText,
  OuterCircle,
  RadioButtonContainer,
} from './RadioButton.styled';

interface DetachedRadioButtonProps {
  checked: boolean;
  disabled?: boolean;
  label?: string;
  onClick?: () => void;
}

export function RadioButton ({
  checked,
  disabled = false,
  label,
  onClick,
}: DetachedRadioButtonProps) {
  return (
    <RadioButtonContainer onClick={onClick} disabled={disabled}>
      <OuterCircle checked={checked} disabled={disabled}>
        <InnerCircle checked={checked} />
      </OuterCircle>
      {label && <LabelText disabled={disabled}>{label}</LabelText>}
    </RadioButtonContainer>
  );
}
